import { createSelector, createFeatureSelector } from '@ngrx/store';

import { AttentionLimitsState } from '../../models/attention-limits.model';

export const getAttentionLimitsState =
  createFeatureSelector<AttentionLimitsState>('attention-limits');

export const getAttentionLimits = createSelector(
  getAttentionLimitsState,
  (state: AttentionLimitsState) => state?.attentionLimits,
);

export const getAttentionLimitsByDate = createSelector(
  getAttentionLimitsState,
  (state: AttentionLimitsState) => state?.attentionLimitsByDate,
);
